/*
 * 작성자 : 김광민
 * 날짜 : 2024.07.04
 * 기능 : 상황판에서 가로 사이즈 5 기상종합 컴포넌트 중 시간별날씨
 */

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PulseLoader } from 'react-spinners';
import { getWeatherIcon as getWeatherIconUtil } from '../../utils/weatherUtils';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  // background-color: var(--weather-bg);
  .loading {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .weatherTime {
    width: 100%;
    flex-grow: 1;
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 0.25rem;
    padding: 0 0.5rem;
    margin: 1rem 0;
    margin: 0.75rem 0;
    .weatherData {
      &.large {
        background-color: rgba(255, 255, 255, 0.1);

        .time-data-top {
          padding: 0.875rem 0;

          .data {
            &.ampm {
              font-size: 0.875rem;
              color: rgba(255, 255, 255, 0.8);
            }
            &.time {
              font-size: 1.125rem;
              font-weight: 700;
            }
          }
        }

        > .info {
          padding: 0.75rem 0;
          gap: 0.5rem;
        }

        .wrapper {
          > .wrapper-data {
            font-size: 1rem;
          }
        }

        // screen 1024px 이하일 때
        @media (max-width: 1024px) {
          .icon {
            svg {
              width: 100%;
            }
          }

          .info-top {
            span {
              font-size: 1.25rem !important;
            }
          }

          .data {
            &.ampm {
              font-size: 0.875rem;
            }
            &.time {
              font-size: 0.875rem !important;
            }
          }

          > .info {
            max-height: 6rem;
          }

          .info-bottom {
            .material-symbols-rounded {
              display: none;
            }
          }

          .wrapper {
            > .wrapper-data {
              .unit {
                &.baseline {
                  font-size: 0.4rem;
                }
              }
            }
          }
        }
      }
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: var(--weather-sub-bg);
      border-radius: 0.5rem;
      padding-top: 1rem;
      padding-top: 0.5rem;
      overflow: hidden;
      .time-data-top {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 0.25rem;

        .data {
          display: flex;
          align-items: center;
          font-size: 0.75rem;
          line-height: 1.25;
          font-weight: 500;
          color: #d5d5d5;
          &.time {
            color: #fff;
          }
        }
      }
      .info {
        padding: 0.25rem 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.125rem;
        background-color: var(--weather-sub-bg-2);
        border-radius: 0.5rem;
      }
      .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        position: relative;
        overflow: visible;
        &:nth-child(4) {
          margin-top: 1rem;
        }
        &:nth-child(5) {
          margin-top: 1.5rem;
        }
        .icon-wrapper {
          flex-grow: 1;
          position: absolute;
          height: 1.25rem;
          width: 1.25rem;
          left: 0.625rem;
          transform: translate(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .material-symbols-rounded {
          font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0;

          &.umbrella {
            font-size: 0.75rem;
            color: var(--filled-blue-dark);
          }
          &.rain {
            font-size: 0.75rem;
            color: var(--filled-blue-deep);
          }
          &.temp {
            color: var(--filled-red-deep);
            font-size: 1rem;
          }
        }
        .wrapper-data {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 0.75rem;
          color: var(--widget-text-primary);
          font-size: 0.75rem;
          font-weight: 600;
          .unit {
            font-size: 0.625rem;
            color: var(--widget-text-tertiary);
            font-weight: 600;
            margin-left: 0.125rem;
            &.baseline {
              // 문자 아래 정렬
              position: relative;
              top: 0.125rem;
            }
          }
        }
      }
      .icon {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 0.5rem;
        padding-bottom: 0.5rem;

        .no-weather-icon {
          color: #fff;
          font-size: 1.25rem;
        }
      }

      .time-data-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        width: 100%;
        padding: 1rem 0.25rem;

        .info-top {
          span {
            text-align: center;
            font-size: 2.125rem;
            font-weight: 700;
            color: #fff;
          }
        }

        .info-bottom {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;

          .info-item {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;

            .icon-wrapper {
              display: flex;
              align-items: center;

              span.material-symbols-rounded {
                font-size: 0.875rem;
                color: rgba(255, 255, 255, 0.8);
                font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0;
              }
            }

            .info-data {
              font-size: 0.875rem;
              font-weight: 600;
              color: rgba(255, 255, 255, 0.8);
            }
          }
        }
      }
    }
  }
`;

const getWeatherIconComponent = (weather: string, size: 'small' | 'large') => {
  if (size === 'small') {
    return getWeatherIconUtil(weather, 36);
  }
  return getWeatherIconUtil(weather, 86);
};

interface TimeInfo {
  ampm: '오전' | '오후';
  hour: number;
  minute: string;
}

function getTime(milliseconds: string): TimeInfo {
  const hour = Number(milliseconds.slice(0, 2));
  const minute = milliseconds.slice(2, 4);
  return {
    ampm: hour >= 12 ? '오후' : '오전',
    hour: hour > 12 ? hour - 12 : hour,
    minute,
  };
}

type Props = {
  timeWeather: TimeWeatherProps[];
  size: 'small' | 'large';
};

type TimeWeatherProps = {
  date: string;
  pcp: string;
  pop: string;
  sky: string;
  sno: string;
  time: string;
  wsd: string;
  tmp: string;
};

const WeatherTotalTime = ({ timeWeather, size }: Props) => {
  const { t } = useTranslation();

  return (
    <Root className={`time-weather-wrap ${size}`}>
      {timeWeather.length === 0 ? (
        <div className='loading'>
          <PulseLoader color='rgb(255, 255, 255)' size='8px' />
        </div>
      ) : (
        <div className='weatherTime'>
          {timeWeather.map((weather: TimeWeatherProps) => {
            const { pop, sky, time, tmp, pcp } = weather;
            const { ampm, hour, minute } = getTime(time);
            return (
              <div key={time} className={`weatherData ${size}`}>
                <div className='time-data-top'>
                  <div className='data ampm'>{ampm}</div>
                  <div className='data time'>{`${hour}:${minute}`}</div>
                </div>
                <div className='icon'>{getWeatherIconComponent(sky, size)}</div>
                {size === 'small' ? (
                  <div className='info'>
                    <div className='wrapper'>
                      <div className='icon-wrapper'>
                        <span className='material-symbols-rounded temp'>thermometer</span>
                      </div>
                      <div className='wrapper-data'>
                        {tmp} <span className='unit'>°</span>
                      </div>
                    </div>
                    <div className='wrapper'>
                      <div className='icon-wrapper'>
                        <span className='material-symbols-rounded rain'>water_drop</span>
                      </div>
                      <div className='wrapper-data'>
                        {pop}
                        <span className='unit'>%</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='time-data-info'>
                    <div className='info-top'>
                      <span className='unit'>{tmp}°</span>
                    </div>
                    <div className='info-bottom'>
                      <div className='info-item'>
                        <div className='icon-wrapper'>
                          <span className='material-symbols-rounded rain'>water_drop</span>
                        </div>
                        <div className='info-data'>
                          {pop}
                          <span className='unit'>%</span>
                        </div>
                      </div>
                      <div className='info-item'>
                        <div className='icon-wrapper'>
                          <span className='material-symbols-rounded umbrella'>water</span>
                        </div>
                        <div className='info-data'>
                          {pcp === '' ? '- ' : pcp === '0' || pcp === '강수없음' ? '0' : pcp.replace('mm', '').replace('미만', '')}
                          <span className='unit baseline'>{pcp.includes('미만') ? 'mm 미만' : 'mm'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </Root>
  );
};

export default WeatherTotalTime;
